import { createAPI } from 'api';

const api = createAPI(`${process.env.REACT_APP_API_URL}/v3/cms`);

export default api;
